import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", {
  id: "home",
  class: "h40 d-flex align-items-center bg-gradient2 section-padding"
}, null, -1)
const _hoisted_2 = {
  id: "process",
  class: "bg-gray-200 section-padding-b"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-sm-8 col-lg-7" }
const _hoisted_6 = { class: "card-step card-form" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header bg-red text-white text-justify" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h6" }, [
    /*#__PURE__*/_createTextVNode(" Tu préstamo ha sido aprobado, por favor selecciona la cantidad que deseas y haz clic en "),
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-warning px-2 pt-0" }, "Continuar")
  ])
], -1)
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = {
  action: "",
  form: "",
  name: "frm",
  novalidate: ""
}
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-xs-12 col-sm-9 col-md-9 col-lg-9 text-center mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "h6 font-weight-bold text-center" }, " ¿Cuánto dinero necesitas? ", -1)
const _hoisted_13 = { class: "form-group mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-offset-2 mt-2" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_15 = { class: "row justify-content-center" }
const _hoisted_16 = { class: "col-xs-12 col-sm-9 col-md-9 col-lg-9 text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "h6 font-weight-bold text-center" }, " Plazo del préstamo ", -1)
const _hoisted_18 = { class: "form-group mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col button-card-footer" }
const _hoisted_22 = { class: "col button-card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("form", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_slider, {
                          min: 20000,
                          max: 150000,
                          step: 1000,
                          pluralize: "amount",
                          defaultValue: 20000,
                          answerKey: "loan",
                          questionKey: "fintonic",
                          onGetValue: _ctx.setValue
                        }, null, 8, ["onGetValue"])
                      ])
                    ])
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_slider, {
                          min: 1,
                          max: 48,
                          step: 1,
                          pluralize: "months",
                          defaultValue: 1,
                          answerKey: "period",
                          questionKey: "fintonic",
                          onGetValue: _ctx.setValue
                        }, null, 8, ["onGetValue"])
                      ])
                    ])
                  ])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Button, {
                      onClick: _ctx.back,
                      iconPos: "left",
                      label: "Regresar",
                      icon: "fas fa-angle-double-left",
                      class: "surface-50 border-0 p-button-rounded font-weight-bold text-900"
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Button, {
                      iconPos: "right",
                      onClick: _ctx.go,
                      label: "Continuar",
                      icon: "fas fa-angle-double-right",
                      class: "bg-yellow-500 border-yellow-500 p-button-raised p-button-rounded font-weight-bold text-900"
                    }, null, 8, ["onClick"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}